
import { DeleteUserButton } from "./delete-user/DeleteUserButton";

interface DeleteContactButtonProps {
  userId: string;
}

export const DeleteContactButton = ({ userId }: DeleteContactButtonProps) => {
  // Render nothing if userId is not provided or invalid
  if (!userId) {
    console.error("DeleteContactButton: No userId provided");
    return null;
  }

  return <DeleteUserButton userId={userId} />;
};
